(() => {
    const state = window.dmPoliciesBlock || {};
    const controllers = state.controllers || new WeakMap();

    // O autoplay só começa no primeiro sinal de uso (rolar, tocar, clicar, tecla): cada avanço
    // lê a posição do slide e, com a página ainda carregando apps e pixels, isso forçava o
    // recálculo do documento inteiro (tarefas de 300-500 ms no celular, o maior bloqueio do tema).
    // Até o primeiro toque ou rolagem, os slides ficam parados no primeiro.
    const userEngaged = state.userEngaged || new Promise((resolve) => {
        const events = ['scroll', 'wheel', 'pointerdown', 'touchstart', 'keydown'];
        const options = { capture: true, passive: true };
        const engage = () => {
            events.forEach((type) => window.removeEventListener(type, engage, options));
            resolve();
        };
        events.forEach((type) => window.addEventListener(type, engage, options));
    });

    const destroy = (component) => {
        const controller = controllers.get(component);
        if (!controller) return;
        controller.destroy();
        controllers.delete(component);
        delete component.dataset.dmAutoplayReady;
    };

    const initialize = (component) => {
        if (!component || controllers.has(component)) return;
        component.dataset.dmAutoplayReady = 'true';

        const mobile = window.matchMedia('(max-width: 767px)');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const delay = Number(component.dataset.dmPoliciesAutoplay) || 5000;
        const abortController = new AbortController();
        const signal = abortController.signal;
        let timer;
        let paused = false;
        let ready = false;
        let visible = false;

        const stop = () => {
            window.clearInterval(timer);
            timer = undefined;
        };
        const start = () => {
            stop();
            if (!ready || !visible || !mobile.matches || reducedMotion.matches || paused || document.hidden) return;
            timer = window.setInterval(() => {
                const nextButton = component.querySelector('button[name="next"]');
                if (!nextButton || typeof component.onButtonClick !== 'function') return;
                component.onButtonClick({
                    currentTarget: nextButton,
                    preventDefault() {}
                });
            }, delay);
        };
        const pause = () => {
            paused = true;
            stop();
        };
        const resume = () => {
            paused = false;
            start();
        };
        // Fora da tela não avança: não há o que ver e o avanço custa layout.
        const visibilityObserver = new IntersectionObserver((entries) => {
            visible = entries[0].isIntersecting;
            start();
        });
        const destroyController = () => {
            stop();
            visibilityObserver.disconnect();
            abortController.abort();
            mobile.removeEventListener?.('change', start);
            reducedMotion.removeEventListener?.('change', start);
        };

        component.addEventListener('pointerenter', pause, { signal });
        component.addEventListener('pointerleave', resume, { signal });
        component.addEventListener('focusin', pause, { signal });
        component.addEventListener('focusout', resume, { signal });
        component.addEventListener('touchstart', pause, { passive: true, signal });
        component.addEventListener('touchend', resume, { passive: true, signal });
        document.addEventListener('visibilitychange', start, { signal });
        mobile.addEventListener('change', start);
        reducedMotion.addEventListener('change', start);

        controllers.set(component, { destroy: destroyController });
        visibilityObserver.observe(component);
        userEngaged.then(() => {
            if (signal.aborted) return;
            ready = true;
            start();
        });
    };

    const initializeWithin = (scope = document) => {
        if (scope.matches?.('[data-dm-policies-autoplay]')) initialize(scope);
        scope.querySelectorAll?.('[data-dm-policies-autoplay]').forEach(initialize);
    };

    const destroyWithin = (scope) => {
        if (scope?.matches?.('[data-dm-policies-autoplay]')) destroy(scope);
        scope?.querySelectorAll?.('[data-dm-policies-autoplay]').forEach(destroy);
    };

    state.controllers = controllers;
    state.userEngaged = userEngaged;
    state.initializeWithin = initializeWithin;
    state.destroyWithin = destroyWithin;
    window.dmPoliciesBlock = state;

    if (!state.listenersReady) {
        state.listenersReady = true;
        document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
        document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
    }
    initializeWithin(document);
})();

